import { faArrowsRotate } from "@fortawesome/pro-regular-svg-icons/faArrowsRotate";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconArrowsRotate: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faArrowsRotate} />;
};
